exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vw-tab-nav{position:fixed;bottom:0}", "", {"version":3,"sources":["/./src/components/nav/bottom-nav.vue"],"names":[],"mappings":"AACA,YACE,eAAgB,AAChB,QAAU,CACX","file":"bottom-nav.vue","sourcesContent":["\n.vw-tab-nav {\r\n  position: fixed;\r\n  bottom: 0;\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-80b192bc!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/nav/bottom-nav.vue
// module id = 100
// module chunks = 0